import { useHistory } from "react-router-dom";
import { trackDashboardCtaClicked } from "analytics";
import { PATHS } from "constants/pathConstants";
import NextMoveCard from ".";
import Translate from "translate/Translate";
import { useNextMoveMemberContext } from "./useNextMoveMemberContext";

const CancerReportingNextMoveCard = () => {
  const history = useHistory();
  const { kitsAlreadyOrdered, hasReportedCancer } = useNextMoveMemberContext();

  const hasOrderedAtLeastOneTest = kitsAlreadyOrdered.length > 0;

  if (!hasOrderedAtLeastOneTest || hasReportedCancer) {
    return null;
  }

  return (
    <NextMoveCard
      id="cancer-survey-next-move"
      title={<Translate text="Are you currently dealing with cancer?" />}
      body={
        <Translate text="We have a dedicated team to help support your journey." />
      }
      link={{
        onClick: () => {
          trackDashboardCtaClicked({
            workflow: "cancer_survey",
            ctaLocation: "next_move_card",
            ctaId: "cancer_survey"
          });
          history.push(PATHS.CANCER_SURVEY);
        },
        text: "Please let us know",
        url: PATHS.CANCER_SURVEY
      }}
    />
  );
};

export default CancerReportingNextMoveCard;
